export enum OrganizationType {
  ZZP = 'ZZP',

  VOF = 'VOF',

  BV = 'BV',

  NV = 'NV',
}
